var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mostRecent)?_c('span',[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.mostRecent.created.toDate(),'HH:mm D/MM/YYYY'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }